import { render, staticRenderFns } from "./ForgotPage.vue?vue&type=template&id=7a862045&scoped=true&"
import script from "./ForgotPage.vue?vue&type=script&lang=js&"
export * from "./ForgotPage.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPage.vue?vue&type=style&index=0&id=7a862045&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a862045",
  null
  
)

export default component.exports